import React from 'react';
import { FilledButton } from 'shared-components/Buttons';
import { OutlineButton } from 'shared-components/Buttons/Outline';
import { StyledWrapper } from './styles';

export const StepNavigatorButtons = ({
  onForward,
  onBack,
  hasFormCheck,
  formValid,
}) => {
  return (
    <StyledWrapper>
      <OutlineButton
        text='Go back'
        color='#00778B'
        borderColor='#00778B'
        fontFamily='Montserrat'
        height='44px'
        onClickHandler={onBack}
      />
      <FilledButton
        background='#00778B'
        height='44px'
        fontFamily='Montserrat'
        onClick={onForward}
        disabled={hasFormCheck && !formValid}>
        Continue
      </FilledButton>
    </StyledWrapper>
  );
};
